import React from 'react'

import { Popover } from 'shared'

export const TaxDeductibilityNotice = () => {
  return (
    <div className="donations-form-tax-deductibility">
      <Popover
        trigger={
          <button type="button" className="simulated-link">
            {i18n.t('donate.iframe.tax_deductibility_notice')}
          </button>
        }
        i18nKey={'donate.iframe.tax_deductibility_notice_popover'}
        popoverId="tooltip-for-tax-deductibility"
      />
    </div>
  )
}
